import React from 'react'
import { createIconComponent } from '../Icon'

const OutlinedLarge = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M520-600v-240h320v240H520ZM120-440v-400h320v400H120Zm400 320v-400h320v400H520Zm-400 0v-240h320v240H120Zm80-400h160v-240H200v240Zm400 320h160v-240H600v240Zm0-480h160v-80H600v80ZM200-200h160v-80H200v80Zm160-320Zm240-160Zm0 240ZM360-280Z"/></svg>
)

const OutlinedSmall = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20"><path d="M538.001-624v-171.999h257.998V-624H538.001Zm-374 171.999v-343.998h257.998v343.998H164.001Zm374 288v-343.998h257.998v343.998H538.001Zm-374 0V-336h257.998v171.999H164.001ZM216-504h154.001v-240H216v240Zm373.999 288H744v-240H589.999v240Zm0-458.999H744V-744H589.999v69.001ZM216-216h154.001v-68.001H216V-216Zm154.001-288Zm219.998-170.999Zm0 218.999ZM370.001-284.001Z"/></svg>
)

const FilledLarge = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M520-600v-240h320v240H520ZM120-440v-400h320v400H120Zm400 320v-400h320v400H520Zm-400 0v-240h320v240H120Z"/></svg>
)

const FilledSmall = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20"><path d="M538.001-624v-171.999h257.998V-624H538.001Zm-374 171.999v-343.998h257.998v343.998H164.001Zm374 288v-343.998h257.998v343.998H538.001Zm-374 0V-336h257.998v171.999H164.001Z"/></svg>
)

export const DashboardIcon = createIconComponent({
  OutlinedLarge,
  OutlinedSmall,
  FilledLarge,
  FilledSmall,
})
